import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
      <Link to="/" className="inline-flex items-center gap-1 hover:text-accent-600 transition-colors cursor-pointer">
        <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}